import React from 'react';
import { components, elements } from '@peachjar/components';
import UploadStaff from './UploadStaffTab';
import SendStaffIntro from './SendStaffIntroTab';

const {
  Notifications: { NotificationContainer },
  Tabber,
  Stepper,
} = components;
const { typography } = elements;
const { Headline1 } = typography;

const generateTabs = (setStaffTabView, staffTabView, haveStaffBeenLoaded) => {
  const tabs = [
    {
      id: 1,
      isActive: staffTabView === 1,
      icon: 'Upload',
      label: 'Upload a CSV file',
      labelSubText: 'with a list of your staff.',
      onClickHandler: () => setStaffTabView(1),
      isLocked: false,
    },
    {
      id: 2,
      isActive: staffTabView === 2,
      icon: 'Email',
      label: 'Introduce Peachjar',
      labelSubText: 'to your staff.',
      onClickHandler: () => {
        if (haveStaffBeenLoaded) setStaffTabView(2);
      },
      isLocked: !haveStaffBeenLoaded,
    },
  ];

  return tabs;
};

const SetupStaffContainer = ({
  haveStaffBeenLoaded,
  haveStaffBeenEmailed,
  ncesSchoolId,
  districtName,
  registrant,
  contactPhoneNumber,
  showTable,
  instructionsViewed,
  templateDownloaded,
  uploading,
  uploadComplete,
  uploadPercentage,
  filename,
  order,
  orderBy,
  data,
  errors,
  sendCSVContents,
  handleInstructionsDownload,
  handleCsvTemplateDownload,
  resetFileUpload,
  hideTable,
  staffSendDisable,
  staffEmailSent,
  handleStaffEmailSubmit,
  history,
  setStaffTabView,
  staffTabView,
  handleFileUpload,
  setShowTable,
}) => (
  <React.Fragment>
    <Headline1 style={{ margin: '1rem 0' }}>Staff Setup</Headline1>
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
      }}
    >
      <Tabber
        tabs={generateTabs(setStaffTabView, staffTabView, haveStaffBeenLoaded)}
      />
    </div>
    <div>
      {staffTabView === 1 ? (
        <UploadStaff
          showTable={showTable}
          instructionsViewed={instructionsViewed}
          templateDownloaded={templateDownloaded}
          uploading={uploading}
          uploadComplete={uploadComplete}
          uploadPercentage={uploadPercentage}
          filename={filename}
          order={order}
          orderBy={orderBy}
          ncesSchoolId={ncesSchoolId}
          data={data}
          errors={errors}
          sendCSVContents={sendCSVContents}
          handleInstructionsDownload={handleInstructionsDownload}
          handleCsvTemplateDownload={handleCsvTemplateDownload}
          resetFileUpload={resetFileUpload}
          hideTable={hideTable}
          handleFileUpload={handleFileUpload}
          setShowTable={setShowTable}
          haveStaffBeenLoaded={haveStaffBeenLoaded}
          setStaffTabView={setStaffTabView}
        />
      ) : (
        <SendStaffIntro
          haveStaffBeenEmailed={haveStaffBeenEmailed}
          districtName={districtName}
          registrant={registrant}
          contactPhoneNumber={contactPhoneNumber}
          staffSendDisable={staffSendDisable}
          staffEmailSent={staffEmailSent}
          handleStaffEmailSubmit={handleStaffEmailSubmit}
          history={history}
          districtName={districtName}
          registrant={registrant}
          contactPhoneNumber={contactPhoneNumber}
        />
      )}
    </div>
  </React.Fragment>
);

export default SetupStaffContainer;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/staff/containers/SetupStaffContainer.jsx